module.exports = __webpack_public_path__ + "img/login_head.031bc825.png";